import { useGetQueryClient } from '@/config/useGetQueryClient.ts';
import { QueryClientProvider } from '@tanstack/react-query';
import React, { PropsWithChildren } from 'react';

export const QueryClientWrapper: React.FC<PropsWithChildren> = props => {
  const queryClient = useGetQueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>
    </>
  );
};
